import ICON__arrow_pointer from '@/assets/icons/font_awesome/arrow-pointer-solid-full.svg?react';
import ICON__paint_brush from '@/assets/icons/font_awesome/paintbrush-solid.svg?react';
import ICON__eraser from '@/assets/icons/lucide/eraser.svg?react';
import { ENUM__color } from '@shared/dto/+image/_enums/ENUM__color';

export enum ENUM__image_brush {
  POINTER = 'POINTER',
  //
  MASK_DRAWER = 'MASK_DRAWER',
  MASK_ERASER = 'MASK_ERASER',
  //
  LINE_ERASER = 'LINE_ERASER',
}

const ENUM = ENUM__image_brush;

export namespace ENUM_UTILS__image_brush {
  export function get_brushes_mask(): ENUM__image_brush[] {
    return [ENUM__image_brush.POINTER, ENUM__image_brush.MASK_DRAWER, ENUM__image_brush.MASK_ERASER];
  }

  export function get_brushes_line(): ENUM__image_brush[] {
    return [ENUM__image_brush.POINTER, ENUM__image_brush.LINE_ERASER];
  }

  export function get_button_icon(type: ENUM__image_brush, class_name: string = ''): JSX.Element {
    const out_map = new Map<ENUM__image_brush, React.ComponentType<{ className?: string }>>([
      [ENUM.POINTER, ICON__arrow_pointer],
      //
      [ENUM.MASK_DRAWER, ICON__paint_brush],
      [ENUM.MASK_ERASER, ICON__eraser],
      //
      [ENUM.LINE_ERASER, ICON__eraser],
    ]);

    // Fallback safely if custom extension method 'get_or_assert' doesn't find it
    const IconComponent = out_map.get_or_assert(type);

    // Return it correctly as a dynamic JSX element passing the class name down
    return <IconComponent className={class_name} />;
  }

  export function get_cursor_icon(type: ENUM__image_brush, class_name = '') {
    const out_map = new Map<ENUM__image_brush, React.ComponentType<{ className?: string }>>([
      [ENUM.POINTER, <></>],
      //
      [ENUM.MASK_DRAWER, ICON__paint_brush],
      [ENUM.MASK_ERASER, ICON__eraser],
      //

      [ENUM.LINE_ERASER, ICON__eraser],
    ]);

    const IconComponent = out_map.get_or_assert(type);

    return <IconComponent className={class_name} />;
  }

  export function get_brush_color(type: ENUM__image_brush) {
    const out_map = new Map<ENUM__image_brush, string>([
      [ENUM.POINTER, ENUM__color.WHITE],
      //
      [ENUM.MASK_DRAWER, ENUM__color.MASK_ACTIVE],
      [ENUM.MASK_ERASER, ENUM__color.MASK_EMPTY],
      //
      [ENUM.LINE_ERASER, ENUM__color.BLACK],
    ]);

    return out_map.get_or_assert(type);
  }
}
